// src/pages/agenda/ListaAgenda.js — Dia e Semana no celular.
//
// Decisão de out/26: no celular a grade de horas vira lista. Sete colunas
// de horário em 360px não deixam ler um nome; a lista mostra horário,
// título e status inteiros, agrupados por dia.
import { Box } from '@mui/material';
import { add, diaLongo } from './datas';
import { FONT_NUM, LILAS, TIPOS, avatar, botaoBase, cor, corDoBloco, ehProposta, faixa, primeiroNome, tomStatus } from './estilo';

function sub(e) {
  if (e.tipo === 'disparo') return `Template ${e.disparo.template} · ${e.disparo.contatos} contatos`;
  const quem = e.responsavel ? primeiroNome(e.responsavel.nome) : null;
  if (e.tipo === 'consulta') return [e.contato?.fone, quem && `com ${quem}`].filter(Boolean).join(' · ');
  return [e.contato?.nome, quem].filter(Boolean).join(' · ');
}

export default function ListaAgenda({ dias, porDia, hoje, selId, onSel, onNovo }) {
  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: '8px 12px 16px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {dias.map((s) => {
        const lista = porDia[s] || [];
        const rotulo = s === hoje ? `Hoje · ${diaLongo(s)}` : s === add(hoje, 1) ? `Amanhã · ${diaLongo(s)}` : diaLongo(s);
        return (
          <Box key={s} component="section" aria-label={diaLongo(s)} sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Box component="h3" sx={{ m: 0, fontSize: '0.72rem', fontWeight: 700, color: s === hoje ? 'var(--ch-green-d)' : 'var(--ch-text2)', letterSpacing: '0.02em' }}>
              {rotulo}
            </Box>
            {lista.length === 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, fontSize: '0.72rem', color: 'var(--ch-text3)', p: '10px 12px', border: '1px dashed var(--ch-bdr2)', borderRadius: '8px' }}>
                Sem compromissos
                {onNovo && (
                  <Box component="button" type="button" onClick={() => onNovo(s)}
                    sx={{ ...botaoBase, border: 'none', bgcolor: 'transparent', color: 'var(--ch-green-d)', fontSize: '0.72rem', fontWeight: 700, p: '8px 4px' }}>
                    + Marcar
                  </Box>
                )}
              </Box>
            )}
            {lista.map((e) => {
              const k = cor(TIPOS[e.tipo].c);
              const c = corDoBloco(e, k);
              const st = tomStatus(e.status_tom);
              const av = e.responsavel ? avatar(e.responsavel.id) : null;
              return (
                <Box key={e.id} component="button" type="button" onClick={() => onSel(e.id)} aria-pressed={selId === e.id}
                  aria-label={ehProposta(e) ? `Proposta do Copiloto: ${faixa(e)} ${e.titulo}` : undefined}
                  sx={{ ...botaoBase, display: 'flex', alignItems: 'stretch', gap: '10px', textAlign: 'left', width: '100%', p: '10px 12px', borderRadius: '10px',
                    border: ehProposta(e) ? `1.5px dashed ${LILAS}` : `1px solid ${selId === e.id ? k.base : 'var(--ch-bdr)'}`,
                    bgcolor: ehProposta(e) ? 'var(--cp-tint)' : 'var(--ch-card)', boxShadow: selId === e.id && ehProposta(e) ? `0 0 0 2px ${LILAS}` : 'var(--sh-sm)', minHeight: 56 }}>
                  <Box sx={{ width: 4, borderRadius: '2px', bgcolor: c.base, flexShrink: 0 }} />
                  <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '3px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
                      <Box component="span" sx={{ fontFamily: FONT_NUM, fontSize: '0.72rem', fontWeight: 600, color: 'var(--ch-text2)', flexShrink: 0 }}>{faixa(e)}</Box>
                      <Box component="span" sx={{ fontSize: '0.62rem', fontWeight: 700, p: '1px 6px', borderRadius: '5px', color: st.cor, bgcolor: st.bg, border: `1px solid ${st.b}`, whiteSpace: 'nowrap', flexShrink: 0 }}>{e.status_txt}</Box>
                    </Box>
                    <Box component="span" sx={{ fontSize: '0.84rem', fontWeight: 700, color: ehProposta(e) ? 'var(--cp-claro)' : 'var(--ch-text)', overflowWrap: 'anywhere' }}>{e.titulo}</Box>
                    {sub(e) && <Box component="span" sx={{ fontSize: '0.7rem', color: 'var(--ch-text2)', overflowWrap: 'anywhere' }}>{sub(e)}</Box>}
                  </Box>
                  {av && (
                    <Box component="span" aria-label={e.responsavel.nome} sx={{ alignSelf: 'center', width: 26, height: 26, flexShrink: 0, borderRadius: '50%', bgcolor: av.bg, color: av.fg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.6rem', fontWeight: 700 }}>
                      {e.responsavel.iniciais}
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        );
      })}
    </Box>
  );
}
